<template>
	<div :class="[{ 'line-height-dense': !!comparisonSubtext }, textAlignClass]" class="flex flex_column w_100">
		<span>{{value}}</span>
		<span class="font_sm tertiary_color" v-if="isDifferent && !!comparisonSubtext">
			{{ comparisonSubtext }}
		</span>
	</div>
</template>
<script>


/* Expected param values:
- `params.comparisonValueGetter`: A function to dynamically get the value to compare against from the row data
- `params.comparisonValueField`: Field name in the row data to retrieve the comparison value from (used if `comparisonValueGetter` is not provided)
- `params.compareFormatted`: A boolean indicating whether to compare formatted values or unformatted (defaults to `true`)
- `params.comparisonSubtextKeyGetter`: A function to dynamically get the key for the subtext translation based on the row data. Keys are expected to have a {comparisonValue} placeholder
- `params.comparisonSubtextKey`: A translation key for the subtext (used if `comparisonSubtextKeyGetter` is not provided)
- `params.textAlignClass`: CSS class to align text (defaults to `"text_right"` if not provided)
*/
export default {
		computed: {
			value() {
				return this.params.valueFormatted || this.params.value;
            },
			comparisonValue() {
				return this.params.comparisonValueGetter ? this.params.comparisonValueGetter(this.params.data) : this.params.data[this.params.comparisonValueField];
			},
			compareFormatted() {
				return this.params.compareFormatted ?? true;
			},
			isDifferent()  {
				return this.comparisonValue !== (this.compareFormatted ? this.params.valueFormatted : this.params.value);
			},
			comparisonSubtextKey() {
				return this.params.comparisonSubtextKeyGetter ? this.params.comparisonSubtextKeyGetter(this.params.data) : this.params.comparisonSubtextKey;
			},
			comparisonSubtext() {
				return this.comparisonSubtextKey ? this.$t(this.comparisonSubtextKey, { comparisonValue: this.comparisonValue }) : this.params.comparisonSubtext;
			},
			textAlignClass() {
				return this.params.textAlignClass || "text_right";
			}
        },
	};
</script>

<style scoped lang="scss">
span {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>